const { getElements } = window.BAO.Utils

class ProductTabs extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.els.trigger?.elements.forEach((trigger) => {
      this.listeners.add(trigger, 'click', this.handleClick.bind(this))
    })
  }

  handleClick (e) {
    const targetKey = e.target.closest(this.els.trigger.selector)?.dataset
      .value

    if (targetKey) {
      this.accordionKeys.forEach((key) => {
        if (key.dataset.drawersAccordion === targetKey) {
          key.setAttribute('aria-expanded', 'true')
          key.nextElementSibling.setAttribute('aria-hidden', 'false')
        } else {
          key.setAttribute('aria-expanded', 'false')
          key.nextElementSibling.setAttribute('aria-hidden', 'true')
        }
      })
    }
  }

  get accordionKeys () {
    return getElements('[data-drawers-accordion]')
  }
}

if (!customElements.get('product-tabs')) {
  customElements.define('product-tabs', ProductTabs)
}
